import { ref } from 'vue'

const property = ref( null )

const loading = ref(false)

const detailed = ref( false )

export { property, loading, detailed }